const ENABLE_DBG = process.env.REACT_APP_RELEASE_STAGE !== 'production'
const noop = () => undefined

export const dbgLog = ENABLE_DBG ? console.debug : () => noop

export const createDbgLogger = (enabled: boolean) => {
  if (ENABLE_DBG && enabled) return console.debug
  return noop
}
